module.exports = __webpack_public_path__ + "static/img/haiwai_03.5ea535e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/callMe/haiwai_03.png
// module id = fX/5
// module chunks = 3